import config from '../config/index'
/**
 * 生成Blob
 * @param {*} dataurl base64数据
 * @param {*} filename 文件名称
 * @returns 
 */
function dataURLtoFile (dataurl, filename) {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}
/**
 * 根据文件格式获取contentType
 * @param {*} fileType 文件格式
 * @returns 
 */
function getContentTypeByFileType (fileType) {
  if (config.contentTypeMap[fileType]) {
    return config.contentTypeMap[fileType]
  } else {
    throw Error("暂无对应文件类型contentType")
  }
}
/**
 * 通过base64数据获取展示文件
 * @param {*} fileName 文件名称
 * @param {*} base64Data base64数据
 * @param {*} fileType 要下载的文件格式
 */
export const getFileByBase64Data = (base64Data, fileType) => {
  const contentType = getContentTypeByFileType(fileType)
  const data = `data:${contentType};base64,${base64Data}`
  return data
}

/**
 * 通过base64数据下载文件
 * @param {*} fileName 文件名称
 * @param {*} base64Data base64数据
 * @param {*} fileType 要下载的文件格式
 */
export const downloadFileByBase64Data = (fileName, base64Data, fileType) => {
  const contentType = getContentTypeByFileType(fileType)
  const blob = dataURLtoFile(`data:${contentType};base64,${base64Data}`, fileName);
  blob.lastModifiedDate = new Date();
  blob.name = fileName;
  const downloadUrl = URL.createObjectURL(blob);

  let a = document.createElement('a')
  a.style.display = "none"
  a.href = downloadUrl
  a.setAttribute("download", fileName)
  document.body.appendChild(a)
  a.click();
  document.body.removeChild(a);
}